import type { MenuProps } from 'antd';
import { hasRole, ROLES_CONTENT_EDITOR, ROLES_PROJECT_ORG_ADMIN } from '../constants/roles';

/** FooterActions `canEdit` ile aynı: dosya → Editor+; klasör/proje → Admin/SuperAdmin */
export function isFileEntryType(entryType: unknown): boolean {
  return entryType === 'File' || entryType === 2 || String(entryType) === 'File';
}

export function canEditEntryInCardMenu(role: string | undefined, entryType: unknown): boolean {
  if (!role) return false;
  if (isFileEntryType(entryType)) {
    return hasRole(role, ...ROLES_CONTENT_EDITOR);
  }
  return hasRole(role, ...ROLES_PROJECT_ORG_ADMIN);
}

/** Proje listesi kartı — her zaman proje varlığı */
export function canEditProjectCardMenu(role: string | undefined): boolean {
  return hasRole(role, ...ROLES_PROJECT_ORG_ADMIN);
}

export function canShowDeleteInCardMenu(role: string | undefined): boolean {
  return hasRole(role, ...ROLES_CONTENT_EDITOR);
}

export function canShowDownloadInCardMenu(isAuthenticated: boolean): boolean {
  return isAuthenticated;
}

function isMenuDivider(it: NonNullable<MenuProps['items']>[number]): boolean {
  return typeof it === 'object' && it !== null && 'type' in it && (it as { type?: string }).type === 'divider';
}

/** Ardışık divider ve sondaki/baştaki divider temizliği */
export function normalizeCardMenuDividers(items: MenuProps['items']): MenuProps['items'] {
  const list = (items || []).filter(Boolean) as NonNullable<MenuProps['items']>;
  const result: NonNullable<MenuProps['items']> = [];
  for (const it of list) {
    if (isMenuDivider(it)) {
      if (result.length === 0) continue;
      const last = result[result.length - 1];
      if (isMenuDivider(last)) continue;
      result.push(it);
    } else {
      result.push(it);
    }
  }
  while (result.length > 0 && isMenuDivider(result[result.length - 1]!)) {
    result.pop();
  }
  return result;
}
